import axios from "axios";
import { store } from "../store";
import {
  setAccessToken,
  clearAccessToken,
  clearRefreshToken,
} from "../store/slices/authSlice";

const API_URL = `${process.env.REACT_APP_API_URL}`;

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use((config) => {
  const state = store.getState();
  const accessToken = state.auth.accessToken;
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return config;
});

// refresh token 요청 중복 방지용 Promise
let refreshTokenPromise = null;

function clearAuthAndRedirect() {
  store.dispatch(clearAccessToken());
  store.dispatch(clearRefreshToken());
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  // TODO: alert 대신 사용자 친화적 UI로 교체 권장
  //alert('서버에 연결할 수 없습니다. (네트워크 또는 인증 오류)');
  window.location.href = '/auth/sign-in';
}

let isErrorHandling = false;

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const state = store.getState();
    
    if (isErrorHandling) {
      return Promise.reject(error);
    }
    isErrorHandling = true;

    // 네트워크 에러 또는 CORS 에러
    if (error.code === 'ERR_NETWORK' || !error.response) {
      clearAuthAndRedirect();
      return Promise.reject(error);
    }

    // 로그인 요청에 대한 모든 에러는 refresh 없이 바로 reject
    if (originalRequest.url && originalRequest.url.indexOf('/user/login') !== -1) {
      return Promise.reject(error);
    }

    // 401 인증 실패 (refresh 시도)
    // 로그인 요청이 아닐 때만 refresh 시도
    if (
      error.response.status === 401 &&
      !originalRequest._retry &&
      originalRequest.url &&
      originalRequest.url.indexOf('/user/login') === -1
    ) {
      originalRequest._retry = true;
      if (!refreshTokenPromise) {
        const refreshToken = state.auth.refreshToken;
        refreshTokenPromise = apiClient.put(`/user/refresh`, { refreshToken })
          .then((response) => {
            const newAccessToken = response.data.accessToken;
            store.dispatch(setAccessToken(newAccessToken));
            return newAccessToken;
          })
          .catch((err) => {
            clearAuthAndRedirect();
            throw err;
          })
          .finally(() => {
            refreshTokenPromise = null;
          });
      }
      try {
        const newAccessToken = await refreshTokenPromise;
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return apiClient(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    // 기타 401 (이미 retry 했거나, refresh 실패)
    if (error.response.status === 401) {
      clearAuthAndRedirect();
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
